<template>
  <p v-if="!recipeSearchStore.loaded" class="has-text-grey is-italic">Loading recipes...</p>
  <template v-else>
    <RecipeList
      :recipe-search-store="recipeSearchStore"
      :selection-mode="false"
      :show-tags="showTags"
      :show-recipe-actions-column="false"
      :show-modified="false"
      :allow-inline-tag-edits="false"
    />
    <PagerWidget
      :model-value="recipeSearchStore.currentPage"
      :total-entries="recipeSearchStore.totalEntries"
      :per-page="recipeSearchStore.perPage"
      @update:model-value="(page) => recipeSearchStore.loadRecipePage(page)"
    />
  </template>
</template>

<script setup>
  import RecipeList from "./recipe-list.vue";
  import PagerWidget from "./pager-widget.vue";
  import { useRecipeSearchStore } from "./stores/recipe-search-store";

  import { recipeFilterIngredientPath } from "~/routes";
  import { onBeforeMount } from "vue";

  const props = defineProps({
    ingredientId: { type: Number, required: true },
    userId: { type: Number, default: null },
    perPage: { type: Number, default: 20 },
  });

  const showTags = props.userId !== null;
  const recipeSearchStore = useRecipeSearchStore(`ingredient-recipes-${props.ingredientId}`);

  onBeforeMount(() => {
    recipeSearchStore.setUserId(props.userId);
    recipeSearchStore.setSearchEndpoint(recipeFilterIngredientPath(props.ingredientId));
    // archived: null keeps archived recipes in the list. They're updated by the
    // change too, so the list must match the affected-recipes count.
    recipeSearchStore.assignInitial({ perPage: props.perPage, archived: null }, { patch: true });
    recipeSearchStore.resetSearch();
  });
</script>
